import { getTime, format } from 'date-fns'

export function deleteSymbols(str) {
	if (str) {
		return str.replace(/[^A-Z0-9]/gi, '');
	}
	return ""
}

export function regexNumeric(str) {
	if (str) {
		return str.replace(/[^0-9]/gi, '');
	}
	return ""
}

export function returnSign(str) {
	return str.includes("?") ? '&' : '?'
}

// ==== Diler taklif linki (invite link) ====
// Diler id ni URL'da ochiq raqam sifatida ko'rsatmaslik uchun maxfiy token.
// Reversible + checksum: token o'zgartirilsa null qaytadi, foydalanuvchi o'zi
// id ni almashtira olmaydi, backendga esa haqiqiy id ketadi.
const DEALER_SALT = 23100 // 0x5a3c

export function encodeDealerToken(id) {
	const n = Number(id)
	if (!Number.isInteger(n) || n <= 0) return ''
	const salted = (n ^ DEALER_SALT) + 100000
	const check = salted % 7
	const payload = salted * 8 + check
	return 'd' + payload.toString(36)
}

export function decodeDealerToken(token) {
	if (!token) return null
	const raw = String(token).trim().toLowerCase()
	const body = raw.startsWith('d') ? raw.slice(1) : raw
	const payload = parseInt(body, 36)
	if (!Number.isFinite(payload) || payload <= 0) return null
	const check = payload % 8
	const salted = Math.floor(payload / 8)
	if (salted % 7 !== check) return null
	const id = (salted - 100000) ^ DEALER_SALT
	return id > 0 ? id : null
}

// Diler uchun to'liq ro'yxatdan o'tkazish (invite) linkini shakllantiradi
export function buildDealerInviteLink(id) {
	const token = encodeDealerToken(id)
	if (!token) return ''
	return `${window.location.origin}/#/register?diler=${token}`
}

export function regexPhoneNumber(str) {
	if (str) {
		return str.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/, "$1$2 $3-$4-$5");
	}
	return ""
}

export function clearTemporaryStorage() {
	localStorage.removeItem('tokenTime')
	localStorage.removeItem('authUser')
	localStorage.removeItem('username')
	localStorage.removeItem('authorities')
	localStorage.removeItem('access_token')
	sessionStorage.clear();
	document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
}

export function findFromArrayById(array, id) {
	if (array.length > 0 && id) {
		return array.filter(x => x.id === id)[0].name;
	}
}

export function formatMoney(amount, decimalCount = null, decimal = ".", thousands = " ") {
	if (!decimalCount && decimalCount !== 0) {
		const state = JSON.parse(localStorage.getItem('state'))
		if (state) {
			//decimalCount = state.settings.decimalPoint
			decimalCount = 2
		} else {
			decimalCount = 0
		}
	}

	try {
		decimalCount = Math.abs(decimalCount);
		decimalCount = isNaN(decimalCount) ? 0 : decimalCount; // 0 was 2

		const negativeSign = amount < 0 ? "-" : "";

		let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
		let j = (i.length > 3) ? i.length % 3 : 0;

		return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
	} catch (e) {
		console.log(e)
	}
}

export function formatDateWithTime(date) {
	if (date) {
		var formattedDate = format(new Date(date), 'dd.MM.yyyy HH:mm');
		return formattedDate
	}
}

export function formatDate(date) {
	if (date) {
		var formattedDate = format(new Date(date), 'dd.MM.yyyy');
		return formattedDate
	}
}

export function formatDateBackend(date) {
	if (date) {
		var formattedDate = format(new Date(date), 'yyyy-MM-dd');
		return formattedDate
	}
}

export function getUnixTime() {
	return getTime(new Date())
}

export function todayDate() {
	return format(new Date(), 'dd.MM.yyyy HH:mm:ss')
}

export function todayDDMMYYYY() {
	return format(new Date(), 'dd.MM.yyyy')
}

export function getHHmm() {
	return format(new Date(), 'HH:mm')
}

export function getUnixTimeByDate(date) {
	return getTime(date)
}

export function formatUnixTime(unixTime) {
	if (unixTime)
		return format(new Date(unixTime), 'dd.MM.yyyy HH:mm:ss')
}